import styled from 'styled-components'

import { TypeStyle, TypeStyleCssFunctionProps } from '@syconium/little-miss-figgy'

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100px;
`

export const LoadingMessage = styled.div<TypeStyleCssFunctionProps>`
  ${TypeStyle.css.eyebrow};
  margin-inline-start: 15px;
  color ${o => o.theme.color.deprecated.obsidianLighter};
  text-transform: uppercase;
  opacity: 70%;
`
